<template>
  <div class="upload">
    <Header :title="'相册管理'" />
    <div class="album-section">
      <nut-textinput
        v-model="album"
        label="相册名称"
        placeholder="未命名相册"
        :clear-btn="false"
        :disabled="false"
        :has-border="false"
      />
    </div>
    <ul class="album-image">
      <li v-for="(item, index) of fileList" :key="index" class="img-item">
        <van-image
          width="25vw"
          height="25vw"
          fit="contain"
          :src="item.resUrl"
          @click="() => showPicture(item.resUrl)"
        />
        <div class="img_delete" @click="() => deleteImage(item, index)">×</div>
        <div
          :class="coverUrl === item.url ? 'is_thumbnail' : 'img_thumbnail'"
          @click="() => setThumbnail(item, index)"
        >
          {{ coverUrl === item.url ? "封面" : "设为封面" }}
        </div>
      </li>
      <li v-for="(item, index) of uploadList" :key="index" class="img-item">
        <van-image
          width="25vw"
          height="25vw"
          fit="contain"
          :src="item.resUrl"
          @click="() => showPicture(item.resUrl)"
        />
        <div class="img_delete" @click="() => deleteImage(item, index)">×</div>
        <div
          :class="coverUrl === item.url ? 'is_thumbnail' : 'img_thumbnail'"
          @click="() => setThumbnail(item, index)"
        >
          {{ coverUrl === item.url ? "封面" : "设为封面" }}
        </div>
      </li>
      <van-uploader
        multiple
        :max-count="12"
        :before-read="beforeRead"
        :after-read="afterRead"
        :max-size="1024 * 1024 * 5"
        @oversize="onOversize"
        @delete="deleteAlbumImage"
      />
      <div style="clear: both" />
    </ul>
    <div class="btn-wrappper">
      <div class="btn btn-cancel" @click="cancel">返回</div>
      <div v-if="id === 0" class="btn btn-edit" @click="onSumbit">确定</div>
      <div v-if="id !== 0" class="btn btn-edit" @click="onSumbit">保存</div>
      <!--      <div v-if="id !== 0 && isEdting" class="btn btn-edit" @click="onSumbit">编辑</div>-->
      <!--      <div v-if="id !== 0 && !isEdting" class="btn btn-edit" @click="onSumbit">上传图片</div>-->
    </div>
    <van-popup v-model="showPopup" class="picture_popup">
      <van-image width="auto" height="auto" fit="contain" :src="curPicUrl" />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Uploader, Image as VanImage, Popup } from 'vant'
import { Toast } from '@nutui/nutui'
import Storage from '@/utils/storage'
import {
  editHallAlbum,
  createHallAlbum,
  getHallAlbumImageData,
  addHallAlbumImage,
  deleteHallAlbumImage
} from '@/api/Personal/Hall'
import { uploadImg } from '@/api/Comm'
import Header from '@/components/Header/Index'

Vue.use(Uploader)
Vue.use(VanImage)
Vue.use(Popup)

export default {
  name: 'Upload',
  components: {
    Header
  },
  data() {
    return {
      hallId: 0,
      id: 0,
      album: '',
      fileList: [],
      albumList: [],
      uploadList: [], // 待提交的图片
      coverUrl: '', // 封面url
      title: '',
      info: '',
      power: 0,
      isEdting: false,
      showPopup: false,
      curPicUrl: ''
    }
  },
  created() {
    this.hallId = this.$route.params.hallId
    this.id = this.$route.params.id
    const album = this.$route.query.album
    this.isEdting = this.album === album ? 'true' : 'false'
    if (Storage.localGet('albumDetail')) {
      const album = Storage.localGet('albumDetail').name
      this.album = album
      const thumbnail = Storage.localGet('albumDetail').thumbnail
      const thumbnailStr = thumbnail.split('/Upload/')
      if (thumbnailStr.length > 1) {
        this.coverUrl = `/Upload/${thumbnailStr[1]}`
      } else {
        this.coverUrl = ''
      }
    }
    this.getAlbumList()
  },
  methods: {
    getAlbumList() {
      getHallAlbumImageData(this.id).then(res => {
        if (res.success) {
          this.albumList = res.data
          this.fileList = this.albumList.map(item => {
            return {
              id: item.id,
              url: item.imgUrl,
              resUrl: this.$resUrl(item.imgUrl),
              title: item.title
            }
          })
        }
      })
    },
    beforeRead(file) {
      if (file instanceof Array) {
        // 判断是否是数组
        file.forEach((v) => {
          this.checkFile(v)
        })
      } else {
        this.checkFile(file)
      }
      return true
    },
    afterRead(file) {
      if (file instanceof Array) {
        file.map((v) => {
          v.status = 'uploading'
          v.message = '上传中...'
          this.uploadImage(v)
        })
      } else {
        file.status = 'uploading'
        file.message = '上传中...'
        this.uploadImage(file)
      }
    },
    // 图片类型检查
    checkFile(file) {
      const format = ['jpg', 'png', 'jpeg', 'bmp']
      const index = file.name.lastIndexOf('.')
      const finalName = file.name.substr(index + 1)
      if (!format.includes(finalName.toLowerCase())) {
        Toast('请上传' + format.join(',') + '格式图片')
        return false
      }
    },
    // 上传
    uploadImage(file) {
      uploadImg(file.file, 'Album/').then(res => {
        if (res.success) {
          this.uploadList.push({
            name: res.data.name,
            url: res.data.url,
            resUrl: this.$resUrl(res.data.url)
          })
          file.status = 'done'
          file.message = '上传成功'
        } else {
          file.status = 'failed'
          file.message = '上传失败'
        }
      })
    },
    onOversize() {
      Toast.fail('文件大小不能超过 5M')
    },
    deleteImage(value, index) {
      if (value.id) {
        deleteHallAlbumImage(value.id).then(res => {
          if (res.success) {
            this.fileList.splice(index, 1)
            Toast.success('删除成功', {
              duration: 500
            })
            if (value.url === this.coverUrl) this.coverUrl = ''
          }
        })
      } else {
        this.uploadList.splice(index, 1)
        Toast.success('删除成功', {
          duration: 500
        })
        if (value.url === this.coverUrl) this.coverUrl = ''
      }
    },
    deleteAlbumImage(file, detail) {
      if (file.id) {
        deleteHallAlbumImage(file.id).then(res => {
          if (res.success) {
            Toast.success('删除成功', {
              duration: 500
            })
          }
        })
      } else {
        this.uploadList.splice(detail.index - this.albumList.length, 1)
        Toast.success('删除成功', {
          duration: 500
        })
      }
    },
    cancel() {
      this.$router.back()
    },
    create() {
      if (this.album !== '') {
        let coverUrl = this.coverUrl
        if (!coverUrl && this.uploadList.length > 0) coverUrl = this.uploadList[0].url
        createHallAlbum(this.hallId, this.album, this.info, coverUrl).then(res => {
          if (res.success) {
            this.id = res.data
            this.upload()
          } else {
            Toast.fail('创建失败')
          }
        })
      } else {
        Toast.fail('请填写相册名称')
      }
    },
    edit() {
      if (this.album === '') {
        Toast.fail('相册名称不能为空')
        return
      }
      let coverUrl = this.coverUrl
      const find1 = this.fileList.find(item => item.url === coverUrl)
      const find2 = this.uploadList.find(item => item.url === coverUrl)
      if (!find1 && !find2) coverUrl = ''
      if (!coverUrl) {
        if (this.fileList.length > 0) {
          coverUrl = this.fileList[0].url
        } else if (this.uploadList.length > 0) coverUrl = this.uploadList[0].url
      }
      editHallAlbum(this.id, this.album, '', coverUrl).then(res => {
        if (res.success) {
          Toast.success('保存成功', {
            duration: 500
          })
        }
      })
    },
    async upload() {
      if (this.album === '') {
        Toast.fail('相册名称不能为空')
        return
      }
      if (this.uploadList.length > 0) {
        let success = true
        for (let i = 0, len = this.uploadList.length; i < len; i++) {
          await addHallAlbumImage(this.id, this.uploadList[i].name, this.uploadList[i].url).then(res => {
            success = !!res.success
            if (i === len - 1 && success) {
              Toast.success('上传成功', {
                duration: 500
              })
              setTimeout(() => {
                this.$router.back()
              }, 500)
            }
          })
        }
      } else {
        if (this.power === 3) {
          Toast.success('创建成功', {
            duration: 500
          })
        } else if (this.power === 2) {
          Toast.success('创建成功，请耐心等待审核', {
            duration: 500
          })
        }
        setTimeout(() => {
          this.$router.back()
        }, 500)
      }
    },
    // 设置封面
    setThumbnail(value, index) {
      if (this.coverUrl === value.url) {
        return
      }
      this.coverUrl = value.url
    },
    showPicture(url) {
      this.showPopup = true
      this.curPicUrl = url
    },
    async onSumbit() {
      if (this.id !== 0) {
        this.upload()
        if (this.isEdting) {
          this.edit()
        }
      } else {
        this.create()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.upload {
  padding-top: 15px;
}

.album-section {
  margin-bottom: 15px;
  background: #fff;
  height: 50px;
  box-sizing: border-box;
  padding: 0 15px;
  display: flex;
  align-items: center;

  ::v-deep {
    .nut-textinput {
      width: 100%;
    }

    .nut-textinput input {
      text-align: right;
    }

    .nut-textinput-disabled input {
      background-color: #ffffff;
      border-color: #ffffff;
      color: #333333;
    }
  }

  .album-item {
    margin: 0 15px;
    display: flex;
    position: relative;
    height: 50px;
    line-height: 50px;
    font-size: 14px;

    .album-title {
      display: inline-block;
      width: 180px;
      text-align: justify;
      overflow: hidden;
      vertical-align: top;
      font-weight: bold;
    }

    .album-selected {
      text-align: right;
      flex: 1;
      font-size: 12px;
      color: gray;
    }

    .album-arrow {
      color: $text-color;
    }

    .album-tip {
      font-size: 10px;
      line-height: 10px;
      z-index: 0;
      position: absolute;
      top: 37px;
      left: 0px;
      color: $primary-color-bright;
    }
  }
}

.album-image {
  margin: 15px 0;
  background: #fff;
  padding: 15px 3vw;
  .img-item {
    float: left;
    border-radius: 5px;
    position: relative;
    margin: 0px 3vw 15px 3vw;
    .img_delete {
      text-align: center;
      color: #fff;
      width: 5.33vw;
      height: 5.33vw;
      background-color: rgba(0, 0, 0, 0.7);
      position: absolute;
      border-radius: 0 1.3333333333333vw 0 100%;
      top: 0;
      right: 0;
    }
    .img_thumbnail {
      position: relative;
      bottom: 0px;
      width: 100%;
      text-align: center;
      // background-color: rgba(100, 100, 99, 0.3);
      color: rgb(175, 175, 175);
      border: 1px solid rgba(202, 202, 202, 0.3);
      font-size: 12px;
      padding: 3px 0px 2px 0px;
      border-radius: 10px;
    }
    .is_thumbnail {
      position: relative;
      bottom: 0px;
      width: 100%;
      text-align: center;
      background-color: rgba(255, 169, 9, 0.1);
      border: 1px solid rgba(255, 169, 9, 0.2);
      color: rgb(255, 169, 9);
      font-size: 12px;
      padding: 3px 0px 2px 0px;
      border-radius: 10px;
    }
  }
  .preview-cover {
    position: absolute;
    box-sizing: border-box;
    bottom: 0;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
  }

  .van-uploader {
    ::v-deep .van-uploader__wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: flex-start;
    }

    ::v-deep .van-uploader__wrapper::after {
      content: "";
      width: 0px;
    }

    ::v-deep .van-uploader__file {
      width: 107px;
      height: 107px;
      border-radius: 5px;
    }

    ::v-deep .van-uploader__upload {
      width: 107px;
      height: 107px;
      border-radius: 5px;
      overflow: hidden;
    }

    ::v-deep .van-image {
      width: 107px;
      height: 107px;
      border-radius: 5px;
      overflow: hidden;
    }

    ::v-deep .van-uploader__mask {
      border-radius: 5px;
      overflow: hidden;
    }

    ::v-deep .van-uploader__preview-delete {
      width: 20px;
      height: 20px;
      border-radius: 0 5px 0 100%;
    }

    ::v-deep .van-uploader__preview-delete-icon {
      font-size: 20px;
    }
  }
}
.picture_popup {
  background-color: rgb(255, 255, 255, 0);
}
.btn-wrappper {
  height: 50px;
  margin: 0 15px 40px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: bold;
  text-align: center;

  .btn {
    width: 150px;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    letter-spacing: 5px;
    text-indent: 5px;
  }

  .btn-cancel {
    color: $primary-color-bright;
    background: #fff;
  }

  .btn-edit {
    color: #fff;
    background: linear-gradient(to right, #f2a612, #f7c827);
  }
}
</style>
